import React, { PureComponent } from 'react'
import { number, any } from 'prop-types'
import { Icon } from 'components'
import { intToStringLeftPad } from 'utils/string'

const timerToString = value => intToStringLeftPad(value, 2)

export class Timer extends PureComponent {
    static propTypes = {
        initial: number,
        extraData: any // timer is restarted if it changes
    }
    static defaultProps = {
        initial: 0
    }
    state = {
        seconds: 0,
        warning: false,
        aboutToExpire: false,
    }

    componentWillMount() {
        this.start(this.props.initial)
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.initial !== this.props.initial || nextProps.extraData !== this.props.extraData) {
            this.start(nextProps.initial)
        }
    }
    componentWillUpdate(nextProps, nextState) {
        if ((this.props.seconds > 0 && nextState.seconds === 0) || nextState.seconds < 0) {
            this.clean()
        }
    }
    componentWillUnmount() {
        this.clean()
    }
    start = (remainingSeconds = 0) => {
        this.setState({ seconds: remainingSeconds, warning: false, aboutToExpire: false })
        if (remainingSeconds > 0) {
            this.timer && clearInterval(this.timer)
            this.timer = setInterval(this.decrementTimer, 1000)
        }
    }
    decrementTimer = () => this.setState({
        seconds: this.state.seconds - 1,
        warning: this.state.seconds < 60,
        aboutToExpire: this.state.seconds < 10
    })
    clean = () => {
        this.timer && clearInterval(this.timer)
        this.setState({ seconds: 0 })
    }

    render() {
        const { seconds, warning, aboutToExpire } = this.state
        return (
            <div id="tour-step-2" className={['StatusBar-Timer', { Warning: warning, AboutToExpire: aboutToExpire }]}>
                <Icon name="timer" />
                <span>{`${timerToString(Math.floor(seconds / 60))}:${timerToString(seconds % 60)}`}</span>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/components/StatusBar/Timer.js